import { Button } from '@material-ui/core';
import styled from 'styled-components';
export const UtilityBarButton = styled(Button).withConfig({
  displayName: "UtilityBarButton",
  componentId: "sc-1oet9zr-0"
})(["padding:3px 8px;font-size:0.85rem;"]);
export default UtilityBarButton;